import 'select2';


function renderFinishes(options) {
	let optionResult = '';
	optionResult += `
	<li class="finish-selector-dropdown__item">
		<img class="finish-selector-dropdown__item-img" src="${options.ThumbnailUrl}" alt="Finish Swatch for ${options.Name}">
		<span class="finish-selector-dropdown__item-name">${options.Name}</span>
	</li>`;

	return optionResult;
}

function changeListener() {
	let finishSelector = $(".js-select-finish");

	finishSelector.on('select2:select', function (e:any) {
		let data:any = e.params.data;

		let url = data.id;
		if (url) {
			(<any>window.location) = url; // redirect
		}
		return false;
	});
}

function initFinishSelectors() {
	(<any>$(".js-select-finish")).select2({
		placeholder: 'Select a Finish',
		selectOnClose: true,
		minimumResultsForSearch: -1, // hide the search box
		templateResult: function (item) {
			if (!item.element) return;
			let finishesData: any = $(item.element).data('finish');

			let resultHTML = `
			<div class="finish-selector-dropdown">
			<ul class="finish-selector-dropdown__list">
				${renderFinishes(finishesData)}
			</ul>
			</div>`;
			return $(resultHTML);
		}, templateSelection: function(item) {
			if (!item.element) return;
			let finishesData: any = $(item.element).data('finish');

			let resultHTML = `
			<div class="finish-selector-dropdown">
			<ul class="finish-selector-dropdown__list">
				${renderFinishes(finishesData)}
			</ul>
			</div>`;
			return $(resultHTML);
		}
	});
}

export function init() {
	changeListener();
	initFinishSelectors();
}
